import React from 'react';
import ScrollToTop from './components/ScrollToTop';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Redes from './pages/Redes';
import NotFound from './pages/NotFound';
import PromoVigente from './components/Promociones/PromoVigente';
import StaticHtmlPage from './components/StaticHtmlPage';

function App() {
  const location = useLocation();
  const showHeader = location.pathname !== '/redes';

  return (
    <>
      <ScrollToTop />
      {showHeader && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portafolio" element={<Portfolio />} />
          <Route path="/servicios" element={<Services />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/redes" element={<Redes />} />
          <Route path="/promovigente" element={<PromoVigente />} />
          <Route
            path="/aviso-de-privacidad"
            element={
              <StaticHtmlPage
                title="Aviso de Privacidad"
                htmlPath="/legal/aviso_privacidad.html"
              />
            }
          />
          <Route
            path="/terminos-de-pago-electronico"
            element={
              <StaticHtmlPage
                title="Términos de Pago Electrónico"
                htmlPath="/legal/terminos_de_pago.html"
              />
            }
          />
          {/* Ruta catch-all para 404 con diseño completo */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
